import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { CityAPI } from "../../../../services/city";
import { UseTrademarkAPI } from "../../../../services/use-trademark";
import MainButton from "../../../../components/button/button";
import { OperationsAPI } from "../../../../services/operations";
import { Add } from "@mui/icons-material";
import PageTitle from "../../../../components/page-title/page-title";
import Back from "../../../../components/back-btn/back-btn";
import { handleResponseStatus } from "../../../../utils/handle-response-status";
import { useNavigate } from "react-router-dom";
import {
  setClearErrorAction,
  setStatusText,
} from "../../../../store/use-trademark/slice";
import Form from "../../../../components/forms/use-trademark/form";

const CreateUseTrademark = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { image } = useSelector((state) => state.image);
  const { listFile } = useSelector((state) => state.file);
  const { status, errorStatus } = useSelector((state) => state.useTrademark);
  const { control, handleSubmit, watch } = useForm({
    defaultValues: {
      tm_or_ob: "",
      country: "",
      image: "",
      upload_file: "",
    },
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      if (Array.isArray(data.upload_file)) {
        data.upload_file = data.upload_file.map((item, index) => {
          const file = listFile[index]?.file || null;
          return {
            ...item,
            file: file,
          };
        });
      }
      data.image = image;
      await dispatch(UseTrademarkAPI.create(data)).unwrap();
    } catch (error) {
      console.error(error.message);
    }
  });

  useEffect(() => {
    dispatch(CityAPI.getCities());
    dispatch(OperationsAPI.getTrademarkObjectionList());
  }, [dispatch]);

  useEffect(() => {
    handleResponseStatus({
      status,
      errorStatus,
      dispatchActions: [{ action: dispatch, payload: setStatusText(null) }],
      successMessage: "Հաջողությամբ ստեղծված է",
      errorMessage: errorStatus,
      navigate,
      navigatePath: "/use-trademark",
      clearErrorAction: () => dispatch(setClearErrorAction()),
    });
  }, [status, errorStatus, dispatch, navigate]);

  return (
    <>
      <Back />
      <PageTitle title="Ավելացնել նոր ապրանքային նշանի օգտագործում" />
      <Form control={control} watch={watch} />
      <MainButton
        type="submit"
        onClick={onSubmit}
        variant="contained"
        startIcon={<Add />}
      >
        Ստեղծել
      </MainButton>
    </>
  );
};

export default CreateUseTrademark;
